import React from 'react';
import { useSelector } from 'react-redux';
import {
    Table,
    TableHeader,
    TableContent,
    TableSubHeader,
    SubHeaderCell,
    TableRow,
    TableCell,
    HorseNrBtn,
    ExpandBtn,
} from './styled';
import useToggle from 'common/hooks/useToggle.ts';
import { thousandsDots } from 'utils/formatters';
import Icon from 'ui/Icon';

/**
 * @param {Product} product
 * @param {Race}    raceDay
 */
const Forecast = ({ product, ongoingRace }) => {
    const racingCardPending = useSelector(
        (state) => state.AISDataProvider.racingCardPending
    );
    const trackPoolPending = useSelector(
        (state) => state.AISDataProvider.trackPoolPending
    );
    const raceDayPending = useSelector(
        (state) => state.AISDataProvider.raceDayPending
    );

    const [shown, toggle, , delayedShown] = useToggle(false, 500);

    if (
        !ongoingRace ||
        raceDayPending ||
        racingCardPending ||
        trackPoolPending ||
        !product.isVProduct()
    ) {
        return null;
    }

    return (
        <Table>
            <TableHeader shown={delayedShown} onClick={toggle}>
                {product.id} værdier efter {ongoingRace.index + 1}. afd.
                <ExpandBtn onClick={toggle}>
                    <Icon
                        iarrowsmooth
                        size="x025"
                        style={{
                            position: 'relative',
                            top: shown ? 0 : '-2px',
                            transition: 'all 200ms linear',
                        }}
                        rotation={shown ? 180 : undefined}
                    />
                </ExpandBtn>
            </TableHeader>
            <TableContent shown={shown}>
                <TableSubHeader>
                    <SubHeaderCell style={{ justifySelf: 'center' }}>
                        Nr.
                    </SubHeaderCell>
                    <SubHeaderCell>Hest</SubHeaderCell>
                    <SubHeaderCell>Værdi</SubHeaderCell>
                </TableSubHeader>
                {/* Content */}
                {ongoingRace.starts.map((starts, i) => (
                    <TableRow>
                        <TableCell style={{ justifySelf: 'center' }}>
                            <HorseNrBtn>{i + 1}</HorseNrBtn>
                        </TableCell>
                        <TableCell style={{ fontWeight: 900 }}>
                            {starts?.horse?.horseNameAndNationality}
                        </TableCell>
                        <TableCell style={{ fontSize: '13px' }}>
                            {starts?.forecastPossibleValue
                                ? thousandsDots(starts?.forecastPossibleValue) +
                                  ' KR.'
                                : starts?.scratched
                                    ? 'Udgået'
                                    : '-'}
                        </TableCell>
                    </TableRow>
                ))}
            </TableContent>
        </Table>
    );
};

export default Forecast;
